import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
// material
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  Tab,
  Box,
  Breadcrumbs,
  Link,
} from '@mui/material';
// components
import Page from '../components/Page';
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';
import Iconify from '../components/Iconify';
import client from '../api/clients';
import { ClientForm, ClientList } from '../sections/client';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import ClientDetails from '../sections/client/ClientDetails';
import { getSubLoginDetails } from 'src/api/newSublogin';
// ----------------------------------------------------------------------

export default function Clients({isReseller}) {
  const theme = useTheme();
  const resellerClientType = (localStorage.getItem('client_type') || '').toUpperCase();
  const resellerDefaultTab = resellerClientType === 'INDIA' ? 'india' : 'us';
  const tabListSx = {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.neutral,
    '& .MuiTab-root': { color: theme.palette.text.secondary },
    '& .MuiTab-root.Mui-selected': { color: theme.palette.text.primary },
    '& .MuiTabs-indicator': { backgroundColor: theme.palette.primary.main },
  };
  const [moremenu, setOpenMenu] = useState({ isOpen: false, id: null });
  const [dataChecker,setDataChecker] = useState([])

 // const [userType, setUserType] = useState(localStorage.getItem('user_type'))

  const [clients, setClients] = useState({
    isLoad: false,
    hasLoaded: false,
    all: [],
    india: [],
    us: [],
    active: [],
    inActive: [],
    logoCacheVersion: 0,
  });

  useEffect(() => {
    setClients((prevClients) => ({
      ...prevClients,
      hasLoaded: false,
    }));

    client.getClients((response) => {
      if (response.status === 200) {
        let allClients = response.data;
        // Add Location column (empty) to each client
        allClients = allClients.map((client) => ({
          ...client,
          Location: client.hasOwnProperty('Location') ? client.Location : '',
          AssignClient: client.hasOwnProperty('AssignClient') ? client.AssignClient : 0
        }));
        
        const indiaClients = allClients.filter((row) => row.ClientType === 'INDIA');
        const usClients = allClients.filter((row) => row.ClientType === 'US');

        setClients((prevClients) => ({
          ...prevClients,
          hasLoaded: true,
          all: allClients,
          india: indiaClients,
          us: usClients,
          active: allClients.filter((row) => row.Status === 1),
          inActive: allClients.filter((row) => row.Status === 0),
          logoCacheVersion: Date.now(),
        }));
      } else {
        setClients((prevClients) => ({
          ...prevClients,
          hasLoaded: true,
          all: [],
          india: [],
          us: [],
          active: [],
          inActive: [],
        }));
      }
    });
    const data ={type:''} 
    getSubLoginDetails(data,(response)=>{
      if(response.status === 200 && response.data.length>0){
       setDataChecker(response.data)
      }
    })
  }, [clients.isLoad]);

  const reloadClientsData = () =>
    setClients((prevClients) => ({ ...prevClients, isLoad: !prevClients.isLoad }));
  const removeClientFromState = (clientId) => {
    setClients((prevClients) => {
      const allClients = prevClients.all.filter((row) => row.ID !== clientId);
      return {
        ...prevClients,
        all: allClients,
        india: prevClients.india.filter((row) => row.ID !== clientId),
        us: prevClients.us.filter((row) => row.ID !== clientId),
        active: allClients.filter((row) => row.Status === 1),
        inActive: allClients.filter((row) => row.Status === 0),
      };
    });
  };

  const [dialog, setOpen] = useState({ isOpen: false, id: null, mode: 'addClient' });
  const handleDialog = (id = null, mode = id ? 'edit' : 'addClient') =>
    setOpen({ ...dialog, isOpen: true, id, mode });

  const [value, setValue] = useState(isReseller ? resellerDefaultTab : 'us');
  const handleChange = (event, newValue) => setValue(newValue);

  useEffect(() => {
    if (isReseller) {
      setValue(resellerDefaultTab);
    }
  }, [isReseller, resellerDefaultTab]);

  const handleMoremenu = (id = null) =>
    setOpenMenu({ ...moremenu, isOpen: true, id });

  return (
    <Page title="Clients">
      <Container maxWidth="xxl" sx={{ p: 0 }}>
        <ClientForm
          total={clients.all}
          dialogData={dialog}
          setOpen={setOpen}
          reloadClientsData={reloadClientsData}
          dataChecker = {dataChecker}
          isReseller = {isReseller}
        />
        <ClientDetails
          dialogData={moremenu}
          setOpen={setOpenMenu}
          reloadClientsData={reloadClientsData}
        />

        <Box sx={{ mb: 4 }}>
	          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
	            <Typography variant="h4">Clients</Typography>
	            <Stack direction="row" spacing={1.5}>	             
	              <Button
	                variant="contained"
	                onClick={() => handleDialog(null, 'addClient')}
	                component={RouterLink}
	                to="#"
	                startIcon={<Iconify icon="eva:plus-fill" />}
	              >
	                Add Client
	              </Button>
                 <Button
	                variant="outlined"
	                onClick={() => handleDialog(null, 'addLocation')}
	                component={RouterLink}
	                to="#"
	                startIcon={<Iconify icon="eva:plus-fill" />}
	              >
	                Add Location
	              </Button>
	            </Stack>
	          </Box>
          {/* <Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
            <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>Clients</Typography>
          </Breadcrumbs> */}
        </Box>

        <Card>
          <TabContext value={value}>
            {!isReseller && (<TabList
              onChange={handleChange}
              aria-label="Country tabs"
              sx={tabListSx}
            >
              <Tab label="US" value="us" />
              <Tab label="INDIA" value="india" />
            </TabList>)}

            <TabPanel value="india" sx={{ p: 0 }}>
              <ClientList
                total={clients.india}
                active={clients.india.filter((row) => row.Status === 1)}
                inactive={clients.india.filter((row) => row.Status === 0)}
                handleDialog={handleDialog}
                reloadClientsData={reloadClientsData}
                removeClientFromState={removeClientFromState}
                handleMoremenu={handleMoremenu}
                isLoaded={clients.hasLoaded}
                logoCacheVersion={clients.logoCacheVersion}
                tab="india"
                isReseller = {isReseller}
              />
            </TabPanel>

            <TabPanel value="us" sx={{ p: 0 }}>
              <ClientList
                total={clients.us}
                active={clients.us.filter((row) => row.Status === 1)}
                inactive={clients.us.filter((row) => row.Status === 0)}
                handleDialog={handleDialog}
                reloadClientsData={reloadClientsData}
                removeClientFromState={removeClientFromState}
                handleMoremenu={handleMoremenu}
                isLoaded={clients.hasLoaded}
                logoCacheVersion={clients.logoCacheVersion}
                tab="us"
                isReseller = {isReseller}
              />
            </TabPanel>
          </TabContext>
        </Card>
      </Container>
    </Page>
  );
}
